import { Box, Grid, makeStyles } from "@material-ui/core";
import { requestStatusColor } from "components/Card/RequestCard";
import { DefaultInfo } from "components/NothingRight";
import TimeLineEventItem from "components/TimeLineEventItem";
import useText from "constants/text";
import { InationalTransportPoint, ITourPoint, NewRequestQuoteContext } from "contexts/RequestQuoteContext";
import { ERequestStatus, ERequestType } from "generated/graphql";
import { MotorCycleIcon, NTIcon, TourNewIcon, TreeCycleIcon, TruckIcon, VanIcon } from "icons";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { DownloadFileIcon, DownloadIcon } from "ui/Icons";
import NTCollipsableStops from "../NationalTransport/Collapse";
import CollipsableAddress from "../SamaPapser/CollipsableAddress";
import { CollipsableStopsTour } from "../Tour/refontTourRequest/Collapse";
import { RightSideSamaPapserContainer, StatusRequest, TimeLineContainer } from "./MainStyles";
import SchedulingDetails from "./RightSideComponents/components/SchedulingDetails";
import VehicleDetails from "./RightSideComponents/components/VehicleDetails";
import TimeLineRequestPoint from "./RightSideComponents/TimeLineRequestPoint";
import { useStyles } from "./TourSideRecap";

export const requestContainerBgColor = {
  MAD: "252, 254, 255",
  NT: "194,202,236",
  TR: "202, 234, 195",
};

export const IconType = {
  MAD: <VanIcon />,
  NT: <NTIcon />,
  TR: <TourNewIcon />,
};

export const VehicleIconType = {
  SCOOTER: <MotorCycleIcon width={45} height={45} />,
  MINI_VAN: <VanIcon width={45} height={45} />,
  VAN: <TruckIcon width={45} height={45} />,
  TRUCK: <TreeCycleIcon width={45} height={45} />,
};

const TimeLineComponentType = {
  NT: (stops: InationalTransportPoint[]) => <TimeLineRequestPoint pointsNT={stops} type={ERequestType.Nt} />,
  TR: (stops: ITourPoint[]) => <TimeLineRequestPoint pointsTour={stops} type={ERequestType.Tr} />,
};
interface IRightSideDetails {
  isForDetails?: boolean;
}

export const useDetailsStyles = makeStyles((theme) => ({
  marge: {
    width: "47%",
    margin: "20px 0 0px",
    "&:nth-child(1)": {
      marginRight: "15px",
    },
    "&:nth-child(3)": {
      marginRight: "15px",
    },
    [theme.breakpoints.down("xs")]: {
      width: "47%",
      "&:nth-child(1)": {
        marginRight: "12px",
      },
      "&:nth-child(3)": {
        marginRight: "12px",
      },
    },
  },

  parcelCardGrid: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
  },

  additionalInfos: {
    display: "flex",
    flexDirection: "column",
    marginTop: "20px",
  },
  additionalInfo: {
    height: "83px",
    color: "#757a93",
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.79,
    letterSpacing: "normal",
    textAlign: "justify",
  },

  details: {
    marginBottom: "-20px",
    color: "#399ebf",
    fontSize: "14px",
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    marginTop: "10px",
    [theme.breakpoints.down("xs")]: {},
  },

  hr: {
    position: "relative",
    top: "-15px",
    width: "80%",
    right: "-38px",
    height: "2px",
    border: "none",
    backgroundColor: "rgba(57, 158, 191, 0.2)",
  },
  downloadDiv: {
    padding: "20px",
    border: "1px solid #757a93",
    borderRadius: "5px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    cursor: "pointer",
  },
  downloadIcon: {
    display: "flex",
  },
  downloadFileIcon: {
    marginLeft: "auto",
  },
  timelineContainer: {
    overflowY: "auto",
    height: "11rem",
    marginLeft: "-40px",
    [theme.breakpoints.down("xs")]: {
      marginLeft: "-20px",
      overflowY: "auto",
      height: "10rem",
    },
  },
  history: {
    color: " #39dd84",
    fontWeight: "bold",
    fontSize: "12px",
    background: "white",
  },
}));

export default function RightSideDetails() {
  const { requestQuote, requestQuoteTour, requestQuoteNT, requestQuoteDetails, setStep } =
    React.useContext(NewRequestQuoteContext);
  const [requestToDisplay, setRequestToDisplay] = useState<any>(null);
  const { text } = useText();
  const styles = useStyles();
  const classes = useDetailsStyles();

  useEffect(() => {
    setRequestToDisplay(requestQuoteDetails || requestQuote || requestQuoteNT || requestQuoteTour);
    // eslint-disable-next-line
  }, [requestQuote, requestQuoteNT, requestQuoteTour, requestQuoteDetails]);

  const handleDownload = () => {
    const url = requestToDisplay.documents[0].link;
    window.open(url, "_blank");
  };

  const renderEvents = () =>
    requestToDisplay?.request_activities?.map((activity: any, index: any) => (
      <TimeLineEventItem
        key={index}
        date={moment(activity?.activity_date).format("L")}
        time={moment(activity?.activity_date).format("LT")}
        dotColor={requestStatusColor[activity?.activity_trigger_action_data]}
        event={
          <StatusRequest
            background-color={requestStatusColor[activity?.activity_trigger_action_data]}
            style={{ width: "100%" }}
          >
            {showHistory(activity)}
          </StatusRequest>
        }
      />
    ));
  const showQuotePDF = () => {
    return (
      requestToDisplay?.status === ERequestStatus.Declined ||
      (ERequestStatus.Requested && requestToDisplay?.documents?.length > 0)
    );
  };
  enum activityTriggerAction {
    requested = "REQUESTED",
    approved = "APPROVED",
    created = "CREATED",
    updated = "UPDATED",
    declined = "DECLINED",
    accepted = "ACCEPTED",
  }

  const showHistory = (activity: any) => {
    if (
      activity?.activity_trigger_action_data === activityTriggerAction.requested &&
      activity?.activity_trigger_action === activityTriggerAction.created 
    ) {
      return activity?.activity_trigger_action_data?.replace(/_/g, " ");
    } else if (
      activity?.activity_trigger_action_data === activityTriggerAction.approved &&
      activity?.activity_trigger_action === activityTriggerAction.created
    ) {
      return activity?.activity_trigger_action_data?.replace(/_/g, " ");
    } else if (
      (requestToDisplay?.documents.length > 0 &&
        activity?.activity_trigger_action === activityTriggerAction.updated &&
        activity?.activity_trigger_action_data === activityTriggerAction.requested)
    ) {
      return <div className={classes.history}>{text.all.quote_available}</div>;
    } else if (
      (requestToDisplay?.documents.length > 0 &&
        activity?.activity_trigger_action === activityTriggerAction.updated &&
        activity?.activity_trigger_action_data === activityTriggerAction.approved) ||
      activity?.activity_trigger_action_data === activityTriggerAction.declined ||
      activity?.activity_trigger_action_data === activityTriggerAction.accepted
    ) {
      return activity?.activity_trigger_action_data?.replace(/_/g, " ");
    }
  };
  React.useEffect(() => {
    setStep(3);
  });
  return (
    <RightSideSamaPapserContainer>
      {requestToDisplay && requestToDisplay?.type ? (
        <>
          <Grid container spacing={1}>
            {requestToDisplay?.type === ERequestType.Nt ? (

          <>
          <Box className={styles.details}>
                National Transport <hr className={styles.hr6} />
              </Box>
              <Grid item xs={12}>
                  <NTCollipsableStops requestQuoteNT={requestToDisplay} />
                </Grid>
                </>
            ) : requestToDisplay?.type === ERequestType.Mad ? (
              <Grid item xs={12}>
                <VehicleDetails requestToDisplay={requestToDisplay} />
              </Grid>
            ) : requestToDisplay?.type === ERequestType.Tr ? (
              <Grid item xs={12}>
                <CollipsableStopsTour requestQuoteTour={requestToDisplay} />
              </Grid>
            ) : (
              <Grid item xs={12}>
                <CollipsableAddress requestQuote={requestToDisplay} />
              </Grid>
            )}
            {requestToDisplay?.productType?.length && (
              <Grid item xs={12}>
                <SchedulingDetails requestToDisplay={requestToDisplay} isDisabled />
              </Grid>
            )}
            {requestToDisplay?.additionnalInfos && (
              <>
                <Grid item xs={12} className={styles.gridStyle}>
                  {text.all.additional_infos}
                  <hr className={styles.hr3} />
                </Grid>
                <Grid item xs={12}>
                  <p className={styles.p}>{requestToDisplay?.additionnalInfos}</p>
                </Grid>
              </>
            )}
            {showQuotePDF() && (
              <>
                <Grid item xs={12} className={styles.gridStyle}>
                  Quote
                  <hr className={styles.hr4} />
                </Grid>
                <Grid item xs={12}>
                  <div onClick={handleDownload} className={classes.downloadDiv}>
                    <div style={{ display: "flex" }}>
                      <DownloadIcon /> &nbsp;&nbsp; Download
                    </div>
                    <div style={{ marginLeft: "auto" }}>
                      <DownloadFileIcon />
                    </div>
                  </div>
                </Grid>
              </>
            )}
            {requestToDisplay?.request_activities?.length > 0 && (
              <>
                <Grid item xs={12} className={styles.gridStyle}>
                  History
                  <hr className={styles.hr5} />
                </Grid>
                <Grid item xs={12}>
                  <TimeLineContainer className={classes.timelineContainer}>{renderEvents()}</TimeLineContainer>
                </Grid>
              </>
            )}
          </Grid>
        </>
      ) : (
        <DefaultInfo />
      )}
    </RightSideSamaPapserContainer>
  );
}
